
import Vuex from 'vuex'
Vue.use(Vuex)

const actions = {
	baocun_person:function(context,val){
		context.commit('m_baocun_person',val)
	}
}
//this.$store.dispatch('baocun_person',obj)

const mutations = {
	m_baocun_person:function(state,val){
		state.person = val
	}
}
//this.$store.commit('m_baocun_person',obj)

const state = {
	person:""
}

export default new Vuex.Store({
	actions,mutations,state
}) 



// WEBPACK FOOTER //
// ./src/store/index.js